import {
  createContext,
  ReactNode,
  RefObject,
  useCallback,
  useContext,
  useRef
} from 'react'

type TPendingRetry = (() => void) | null
type TPendingRetryRef = RefObject<TPendingRetry>

const PendingRetryContext = createContext<TPendingRetryRef | null>(null)

export const PowerModeRetryContextProvider = ({
  children
}: {
  children: ReactNode
}) => {
  const ref = useRef<TPendingRetry>(null)
  return (
    <PendingRetryContext.Provider value={ref}>
      {children}
    </PendingRetryContext.Provider>
  )
}

export const useRunWithPowerModeRetry = () => {
  const ref = useContext(PendingRetryContext)
  return useCallback(
    (action: () => void) => {
      if (ref) ref.current = action
      action()
    },
    [ref]
  )
}

export const usePendingRetryRef = () => {
  const ref = useContext(PendingRetryContext)
  if (!ref) {
    throw new Error(
      'usePendingRetryRef must be used within PowerModeRetryContextProvider'
    )
  }
  return ref
}
